import { useGetHeaderTemplate } from 'app/modules/Reports/Preview/hooks';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';

export const HeaderPreview = () => {
  const { t, i18n } = useTranslation();
  const { data, error, loading, execute } = useGetHeaderTemplate(i18n.language);
  if (error || loading) {
    return <></>;
  }

  const currentTemplate = data?.template;
  return <>{ReactHtmlParser(currentTemplate ? currentTemplate : '')}</>;
};
